import type { SupabaseClient } from "@supabase/supabase-js";

/**
 * Whether a client_user may use the portal: active grant in either
 * contact_user_access (single contact) or company_user_access (company-wide).
 */
export async function userHasActiveClientPortalAccess(
  supabase: SupabaseClient,
  userId: string
): Promise<{ ok: true } | { ok: false; message: string }> {
  const [contactRes, companyRes] = await Promise.all([
    supabase
      .from("contact_user_access")
      .select("contact_id")
      .eq("user_id", userId)
      .eq("is_active", true)
      .limit(1),
    supabase
      .from("company_user_access")
      .select("company_id")
      .eq("user_id", userId)
      .eq("is_active", true)
      .limit(1),
  ]);

  if (contactRes.error) {
    return { ok: false, message: contactRes.error.message };
  }
  if (companyRes.error) {
    return { ok: false, message: companyRes.error.message };
  }

  const hasGrant =
    (contactRes.data?.length ?? 0) > 0 || (companyRes.data?.length ?? 0) > 0;

  if (!hasGrant) {
    return { ok: false, message: "no_grants" };
  }

  return { ok: true };
}
